/* ==========================================================================
   Inline personalisation options — U&S Clothing
   assets/personalise-inline.js

   Adds font, colour and position pickers to the existing on-page
   personalisation blocks. No modal, no steps — the shopper fills the text
   field as they always have and these sit directly beneath it.

   Nothing in sections/main-product.liquid is touched. That file is 5,600
   lines and drives 318 products; adding a block to its schema is a needless
   risk when the same result comes from inserting into the rendered page and
   binding the values to the add-to-cart form.
   ========================================================================== */
(function () {
  'use strict';

  /* Run once per page — see the note in customise-wizard.js. */
  if (window.__piInlineLoaded) return;
  window.__piInlineLoaded = true;


  var cfg = null, FONTS = [], COLOURS = [];
  var state = { texts: {}, font: null, colour: null, position: null, image: null };
  var built = false;

  /* ------------------------------------------------------------------ config */

  function readConfig() {
    var tag = document.querySelector('script[id^="InlinePersonaliseConfig-"]');
    if (!tag) return null;
    try { return JSON.parse(tag.textContent); }
    catch (e) { console.warn('[personalise-inline] bad config', e); return null; }
  }

  /* Each line is  Kind[:Label[:Limit]]  — for example:
       Text
       Text:Enter Date
       Text:Enter Your Name:20
       Position:Where should it go?
     Kind is matched case-insensitively; the label keeps whatever case the
     client typed, because it is shown to the shopper and, for text fields,
     becomes the name on the order. */
  var WANTS = [];

  function parseWants(lines) {
    var out = [];
    (lines || []).forEach(function (raw) {
      if (!raw) return;
      var bits  = String(raw).split(':');
      var kind  = (bits[0] || '').trim().toLowerCase();
      var label = (bits[1] || '').trim();
      var limit = parseInt((bits[2] || '').trim(), 10);
      if (!kind) return;
      out.push({ kind: kind, label: label, max: (limit > 0 ? limit : 40) });
    });
    return out;
  }

  function wants(kind) {
    for (var i = 0; i < WANTS.length; i++) if (WANTS[i].kind === kind) return WANTS[i];
    return null;
  }

  function wantsAll(kind) {
    return WANTS.filter(function (w) { return w.kind === kind; });
  }

  /* Same formats the wizard accepts, so one list in Theme settings feeds both.
       Oswald
       Oswald:600 | Condensed
       Sacramento = sacramento.woff2 | Script      (uploaded file) */
  function parseFonts(lines) {
    var out = [];
    (lines || []).forEach(function (raw) {
      if (!raw) return;
      var parts = String(raw).split('|');
      var left  = parts[0].trim();
      var tag   = (parts[1] || '').trim();
      if (!left) return;

      var eq   = left.split('=');
      var spec = (eq.length > 1 ? eq[1] : eq[0]).trim();
      if (!spec) return;

      /* A full URL contains colons of its own, so it must be recognised
         before the weight is split off. */
      var isUrl  = /^https?:\/\//i.test(spec);
      var bits   = isUrl ? [spec] : spec.split(':');
      var family = bits[0].trim();
      var weight = isUrl ? '' : (bits[1] || '').trim();
      if (!family) return;

      var isFile = isUrl || /\.(woff2|woff|ttf|otf)(\?.*)?$/i.test(family);
      var display = eq.length > 1 ? eq[0].trim() : family;
      if (!display) return;

      out.push({
        name: display,
        tag: tag,
        file: isFile ? family : null,
        css: isFile ? "'" + display + "', sans-serif" : "'" + family + "', sans-serif",
        google: isFile ? null : family.replace(/\s+/g, '+') + (weight ? ':wght@' + weight : '')
      });
    });
    return out;
  }

  /* Used when Theme settings → Customisation → Colour list is empty. The
     wizard carries the same list; without it here the colour picker silently
     did not appear on inline products while the font picker did, because an
     empty list and a disabled feature looked identical to the code. */
  var DEFAULT_COLOURS = [
    'White:#FFFFFF','Mallard Teal:#16646B','Sky:#7FB9E0','Silver:#C8CBCC',
    'Sand:#E4D5BE','Rose Gold:#D9A08C','Red:#C8102E','Purple:#3E1F6D',
    'Purple Pansy:#7D3F98','Champagne:#E3D9B8','Black:#101010',
    'Pink:#F26FA2','Pale Blue:#3EB1E5','Orange:#E8631A','Olive Green:#2F3B15',
    'Cream:#F2ECD8','Nugget Gold:#E0A800','Neon Yellow:#F5E400','Navy:#14213D',
    'Mint:#3FBF9A','Brown:#6B3A17','Baby Pink:#F7C5D5',
    'Maroon:#6B0F1A','Magenta:#D6006E','Lilac:#8E7BC1','Light Green:#4CAF50',
    'Light Brown:#A9732F','Green:#159B4A','Light Blue:#2E9BD6','Grey:#9AA0A6',
    'Gold:#D9A520','Bright Pink:#FF3B4E','Autumn Orange:#E8781E',
    'Forest Green:#14512B','Fluorescent Lime:#8FE01A','Flamingo Pink:#FF1F8F',
    'Dark Grey:#4A4A4A','Dark Brown:#2E1A0F','Dark Gold:#C08A17',
    'Dark Blue:#123C7A','Charcoal:#2B2B2B','Bottle Green:#0F4436','Yellow:#F5D000'
  ];

  function parseColours(lines) {
    var out = [];
    (lines && lines.length ? lines : DEFAULT_COLOURS).forEach(function (raw) {
      if (!raw) return;
      var i = String(raw).lastIndexOf(':');
      if (i < 1) return;
      var name = String(raw).slice(0, i).trim();
      var hex  = String(raw).slice(i + 1).trim();
      if (!name || !/^#?[0-9a-f]{3,8}$/i.test(hex)) return;
      if (hex[0] !== '#') hex = '#' + hex;
      out.push({ name: name, hex: hex });
    });
    return out.length ? out : parseColours(DEFAULT_COLOURS);
  }

  /* Fonts load once, on first interaction with the page rather than at load,
     so a shopper who never personalises never downloads them. */
  /* Faces load on demand. A full embroidery list is 25-30 files; fetching
     them all on page load would be a needless download for the many shoppers
     who never open the font list. The selected face loads when the panel is
     built, the rest only when the list is opened. */
  var loadedFaces = {};

  function faceUrl(file) {
    return /^https?:\/\//i.test(file) ? file : (cfg.fontAssetBase || '') + file;
  }

  function loadFont(f) {
    if (!f || loadedFaces[f.name]) return;
    loadedFaces[f.name] = true;

    if (f.file) {
      var fmt = /woff2$/i.test(f.file) ? 'woff2'
              : /woff$/i.test(f.file)  ? 'woff'
              : /otf$/i.test(f.file)   ? 'opentype' : 'truetype';
      var st = document.createElement('style');
      st.textContent = "@font-face{font-family:'" + f.name + "';"
        + "src:url('" + faceUrl(f.file) + "') format('" + fmt + "');"
        + "font-display:swap}";
      document.head.appendChild(st);
    } else if (f.google) {
      var link = document.createElement('link');
      link.rel = 'stylesheet';
      link.href = 'https://fonts.googleapis.com/css2?family=' + f.google + '&display=swap';
      document.head.appendChild(link);
    }
  }

  function loadAllFonts() { FONTS.forEach(loadFont); }

  /* --------------------------------------------------------------- helpers */

  function esc(s) {
    return String(s).replace(/[&<>"]/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c];
    });
  }

  function atcForm() {
    return document.querySelector('form[data-type="add-to-cart-form"]')
        || document.querySelector('product-form form');
  }

  /* A hidden input carries each answer into the cart. Using the form
     attribute means it works wherever on the page we end up inserting. */
  function hidden(name, formId) {
    var i = document.createElement('input');
    i.type = 'hidden';
    i.name = 'properties[' + name + ']';
    if (formId) i.setAttribute('form', formId);
    return i;
  }

  /* ---------------------------------------------------------------- upload */

  /* Same destination as the theme's own upload block, so artwork from either
     system lands in the same place for the print team. */
  /* XHR, not fetch — fetch cannot report upload progress, and a silent
     spinner on a 4MB phone photo reads as a stall. Sent at full resolution:
     shrinking it would move the bar faster at the cost of print sharpness. */
  function uploadImage(file, onProgress) {
    if (!cfg.imgbbKey) return resize(file, 900);

    return new Promise(function (resolve, reject) {
      var fd = new FormData();
      fd.append('image', file);

      var xhr = new XMLHttpRequest();
      xhr.open('POST', 'https://api.imgbb.com/1/upload?key=' + cfg.imgbbKey);

      xhr.upload.onprogress = function (e) {
        if (!onProgress) return;
        onProgress(e.lengthComputable ? Math.round((e.loaded / e.total) * 100) : null);
      };

      xhr.onload = function () {
        var data;
        try { data = JSON.parse(xhr.responseText); } catch (err) { data = null; }
        if (xhr.status >= 200 && xhr.status < 300 && data && data.success && data.data && data.data.url) {
          if (onProgress) onProgress(100);
          resolve(data.data.url);
        } else {
          reject(new Error('upload rejected'));
        }
      };
      xhr.onerror = function () { reject(new Error('network error')); };
      xhr.ontimeout = function () { reject(new Error('timed out')); };
      xhr.timeout = 120000;
      xhr.send(fd);
    });
  }

  function resize(file, max) {
    return new Promise(function (res, rej) {
      var img = new Image(), url = URL.createObjectURL(file);
      img.onload = function () {
        var sc = Math.min(1, max / Math.max(img.width, img.height));
        var c = document.createElement('canvas');
        c.width = Math.round(img.width * sc);
        c.height = Math.round(img.height * sc);
        c.getContext('2d').drawImage(img, 0, 0, c.width, c.height);
        URL.revokeObjectURL(url);
        res(c.toDataURL('image/jpeg', 0.82));
      };
      img.onerror = function () { URL.revokeObjectURL(url); rej(new Error('bad image')); };
      img.src = url;
    });
  }

  /* ------------------------------------------------------------------- UI */

  function fontPicker(spec, onPick) {
    var wrap = document.createElement('div');
    wrap.className = 'pi-field';
    var current = FONTS[0];
    loadFont(current);

    wrap.innerHTML =
      '<label class="pi-label">' + esc(spec.label || 'Font') + '</label>'
      + '<div class="pi-fontpick">'
      +   '<button type="button" class="pi-fontpick__btn" aria-haspopup="listbox" aria-expanded="false">'
      +     '<span class="pi-fontpick__name">' + esc(current.name) + '</span>'
      +     '<span class="pi-fontpick__chev">&#9662;</span>'
      +   '</button>'
      +   '<div class="pi-fontpick__list" role="listbox" hidden></div>'
      + '</div>';

    var btn  = wrap.querySelector('.pi-fontpick__btn');
    var name = wrap.querySelector('.pi-fontpick__name');
    var list = wrap.querySelector('.pi-fontpick__list');
    name.style.fontFamily = current.css;

    FONTS.forEach(function (f) {
      var o = document.createElement('button');
      o.type = 'button';
      o.className = 'pi-fontpick__opt';
      o.setAttribute('role', 'option');
      o.setAttribute('aria-selected', f.name === current.name);
      o.innerHTML = '<span class="pi-fontpick__sample" style="font-family:' + f.css + '">'
        + esc(f.name) + '</span>'
        + (f.tag ? '<span class="pi-fontpick__tag">' + esc(f.tag) + '</span>' : '');
      o.addEventListener('click', function () {
        state.font = f.name;
        name.textContent = f.name;
        name.style.fontFamily = f.css;
        Array.prototype.forEach.call(list.children, function (el) {
          el.setAttribute('aria-selected', el.textContent.indexOf(f.name) === 0);
        });
        list.hidden = true;
        btn.setAttribute('aria-expanded', 'false');
        onPick();
      });
      list.appendChild(o);
    });

    btn.addEventListener('click', function (e) {
      e.stopPropagation();
      loadAllFonts();          /* only now is the whole list needed */
      var opening = list.hidden;
      list.hidden = !opening;
      btn.setAttribute('aria-expanded', String(opening));
    });
    document.addEventListener('click', function () {
      if (!list.hidden) { list.hidden = true; btn.setAttribute('aria-expanded', 'false'); }
    });

    return wrap;
  }

  function colourPicker(spec, onPick) {
    var wrap = document.createElement('div');
    wrap.className = 'pi-field';
    wrap.innerHTML =
      '<label class="pi-label">' + esc(spec.label || 'Font colour') + '</label>'
      + '<p class="pi-help">Selected: <b class="pi-swatch-name">' + esc(state.colour) + '</b></p>'
      + '<div class="pi-swatches" role="radiogroup" aria-label="Font colour"></div>';

    var grid   = wrap.querySelector('.pi-swatches');
    var nameEl = wrap.querySelector('.pi-swatch-name');

    COLOURS.forEach(function (c) {
      var b = document.createElement('button');
      b.type = 'button';
      b.className = 'pi-swatch';
      b.setAttribute('role', 'radio');
      b.setAttribute('aria-checked', c.name === state.colour);
      b.setAttribute('aria-label', c.name);
      b.title = c.name;
      b.style.setProperty('--sw', c.hex);
      b.innerHTML = '<span class="pi-swatch__tick" aria-hidden="true">&#10003;</span>';
      b.addEventListener('click', function () {
        state.colour = c.name;
        nameEl.textContent = c.name;
        Array.prototype.forEach.call(grid.children, function (el) {
          el.setAttribute('aria-checked', el.title === c.name);
        });
        onPick();
      });
      grid.appendChild(b);
    });

    return wrap;
  }

  function positionPicker(spec, onPick) {
    var wrap = document.createElement('div');
    wrap.className = 'pi-field';
    wrap.innerHTML =
      '<label class="pi-label">' + esc(spec.label || 'Position') + '</label>'
      + '<div class="pi-positions" role="radiogroup" aria-label="Position"></div>';

    var row = wrap.querySelector('.pi-positions');
    cfg.positions.forEach(function (p) {
      var b = document.createElement('button');
      b.type = 'button';
      b.className = 'pi-position';
      b.setAttribute('role', 'radio');
      b.setAttribute('aria-checked', p === state.position);
      b.textContent = p;
      b.addEventListener('click', function () {
        state.position = p;
        Array.prototype.forEach.call(row.children, function (el) {
          el.setAttribute('aria-checked', el.textContent === p);
        });
        onPick();
      });
      row.appendChild(b);
    });

    return wrap;
  }

  /* A product may have no personalisation block of its own. Listing "Text"
     gives it one here.

     The wrapper carries product__personalize-input on purpose: that is the
     class require-artwork.js already looks for, so this field counts as
     required with no change needed there. */
  /* A product may have no personalisation block of its own. Listing "Text"
     gives it one here, and the label the client typed becomes both the
     prompt on the page and the name on the order — so a date field reads
     "Enter Date: 12.08.2025" rather than something generic.

     The wrapper carries product__personalize-input on purpose: that is the
     class require-artwork.js already looks for, so these fields count as
     required with no change needed there. */
  /* A product may have no personalisation block of its own. Listing "Text"
     gives it one here, and the label the client typed becomes both the prompt
     on the page and the name on the order — so a date field reads
     "Enter Date: 12.08.2025" rather than something generic.

     The visible input carries the cart property itself rather than shadowing
     a hidden one. That matters: require-artwork.js decides whether text is
     missing by looking for a VISIBLE input with a properties[] name, and a
     hidden twin is deliberately skipped there. With the name on the hidden
     input only, an empty text field looked like no text field at all and the
     buttons stayed available.

     The wrapper carries product__personalize-input for the same reason — it
     is the class that guard already looks for. */
  function textField(spec, index, formId, onPick) {
    var label = spec.label || 'Your text';
    var id    = 'piText' + index;

    var wrap = document.createElement('div');
    wrap.className = 'pi-field pi-text product__personalize-input';
    wrap.innerHTML =
      '<label class="pi-label" for="' + id + '">' + esc(label) + '</label>'
      + '<p class="pi-help">Please add the required details. If no details are added, we’ll print and ship the default design</p>'
      + '<textarea id="' + id + '" class="pi-input pi-input--multi" rows="2"'
      + ' maxlength="' + spec.max + '"'
      + ' name="properties[' + esc(label) + ']"'
      + (formId ? ' form="' + formId + '"' : '') + '></textarea>'
      + '<div class="pi-count"><span>0</span>/' + spec.max + '</div>';

    var inp = wrap.querySelector('textarea');
    var cnt = wrap.querySelector('.pi-count span');

    /* Grows with what is typed. A box that scrolls inside itself hides the
       first line, which on a phone the shopper never notices. */
    function grow() {
      inp.style.height = 'auto';
      inp.style.height = inp.scrollHeight + 'px';
    }

    inp.addEventListener('input', function () {
      state.texts[label] = inp.value;
      cnt.textContent = inp.value.length;
      grow();
      onPick();
    });
    /* Built before it is in the document, so the first measure has to wait
       for layout or scrollHeight reads as zero. */
    setTimeout(grow, 0);

    return wrap;
  }

  /* The few rules the multi-line box needs on top of .pi-input.

     They are injected rather than put in personalise-inline.css so this
     change is one file, not two — .pi-input sets a fixed height and side-only
     padding, which on a textarea puts the first line hard against the top. */
  function multiLineStyles() {
    if (document.getElementById('pi-multiline-css')) return;
    var st = document.createElement('style');
    st.id = 'pi-multiline-css';
    st.textContent = '.pi-input--multi{'
      + 'min-height:5.2rem;height:auto;padding:1.1rem 1.2rem;'
      + 'line-height:1.35;resize:none;overflow:hidden;'
      + 'font-family:inherit;display:block;box-sizing:border-box}';
    document.head.appendChild(st);
  }

  function imagePicker(spec, onPick) {
    var wrap = document.createElement('div');
    wrap.className = 'pi-field pi-image';
    wrap.innerHTML =
      '<label class="pi-label">' + esc(spec.label || 'Your image') + '</label>'
      + '<div class="pi-drop">'
      +   '<strong>Choose an image</strong>'
      +   '<small>JPG, PNG or WEBP &middot; at least 1000px wide for a sharp print</small>'
      + '</div>'
      + '<div class="pi-progress" hidden>'
      +   '<div class="pi-progress__bar"><i></i></div>'
      +   '<p class="pi-progress__label">Uploading&hellip;</p>'
      + '</div>'
      + '<input type="file" accept="image/*" hidden>';

    var drop = wrap.querySelector('.pi-drop');
    var file = wrap.querySelector('input[type=file]');
    var note = wrap.querySelector('.pi-progress');
    var bar  = wrap.querySelector('.pi-progress__bar i');
    var lbl  = wrap.querySelector('.pi-progress__label');

    drop.addEventListener('click', function () { file.click(); });

    file.addEventListener('change', function () {
      var f = file.files[0];
      if (!f) return;

      if (f.size > 5 * 1024 * 1024) {
        note.hidden = false;
        bar.style.width = '0%';
        lbl.textContent = 'That file is over 5MB. Please choose a smaller one.';
        return;
      }

      state.image = null;          /* not usable until the upload finishes */
      onPick();

      var preview = URL.createObjectURL(f);
      drop.classList.add('pi-drop--filled');
      drop.innerHTML = '<img src="' + preview + '" alt="">'
        + '<div><strong>' + esc(f.name) + '</strong><small>Tap to replace</small></div>';

      note.hidden = false;
      bar.style.width = '0%';
      lbl.textContent = 'Uploading…';

      uploadImage(f, function (pct) {
        if (pct === null) { bar.style.width = '100%'; lbl.textContent = 'Uploading…'; return; }
        bar.style.width = pct + '%';
        lbl.textContent = pct < 100 ? 'Uploading… ' + pct + '%' : 'Finishing up…';
      }).then(function (url) {
        state.image = url;
        note.hidden = true;
        onPick();
      }).catch(function () {
        state.image = null;
        note.hidden = false;
        bar.style.width = '0%';
        lbl.textContent = 'That image would not upload. Try again, or use a smaller file.';
        onPick();
      });
    });

    return wrap;
  }

  /* ----------------------------------------------------------------- build */

  function build() {
    if (built) return true;

    /* A product may have no text field of its own — the client might want
       only an image, or only a colour. In that case the panel has nothing to
       sit under, so it goes above the buttons instead. */
    var fields = document.querySelectorAll('.product__personalize-input');

    var form = atcForm();
    var formId = form ? form.getAttribute('id') : null;
    if (!formId) return false;

    built = true;

    var box = document.createElement('div');
    box.className = 'pi-block';
    multiLineStyles();

    var inputs = {};
    function sync() {
      if (inputs.font)     inputs.font.value     = state.font || '';
      if (inputs.colour)   inputs.colour.value   = state.colour || '';
      if (inputs.position) inputs.position.value = state.position || '';
      if (inputs.image)    inputs.image.value    = state.image || '';
    }

    /* one field per Text line, in the order the client listed them */
    wantsAll('text').forEach(function (spec, i) {
      box.appendChild(textField(spec, i, formId, sync));
    });

    var fontSpec = wants('font');
    if (fontSpec && FONTS.length) {
      state.font = FONTS[0].name;
      inputs.font = hidden('Font', formId);
      box.appendChild(fontPicker(fontSpec, sync));
      box.appendChild(inputs.font);
    }

    var colourSpec = wants('colour');
    if (colourSpec && COLOURS.length) {
      var black = COLOURS.filter(function (c) { return c.name === 'Black'; })[0];
      state.colour = (black || COLOURS[0]).name;
      inputs.colour = hidden('Font colour', formId);
      box.appendChild(colourPicker(colourSpec, sync));
      box.appendChild(inputs.colour);
    }

    /* Products already using the theme's own upload block keep it — adding a
       second uploader would give the shopper two boxes for one image. */
    var imageSpec = wants('image');
    if (imageSpec && !cfg.hasOldUploader && !document.querySelector('.pib-wrapper')) {
      inputs.image = hidden('Image', formId);
      box.appendChild(imagePicker(imageSpec, sync));
      box.appendChild(inputs.image);
    }

    var positionSpec = wants('position');
    if (positionSpec && cfg.positions && cfg.positions.length) {
      state.position = cfg.positions[0];
      inputs.position = hidden('Position', formId);
      box.appendChild(positionPicker(positionSpec, sync));
      box.appendChild(inputs.position);
    }

    if (!box.children.length) return true;

    /* Where the panel goes, in order of preference.

       The client wants these questions right after the price, before colour
       and size — they are the reason the shopper is on the page, so they
       should not be buried under the variant pickers. Falling back through
       the other two positions means the panel still lands somewhere sensible
       on a product laid out differently. */
    var price = document.querySelector('.product__price-block');
    var last  = fields.length ? fields[fields.length - 1] : null;
    var btns  = form.querySelector('.product-form__buttons')
             || form.querySelector('.product-form__submit');

    if (price && price.parentNode) {
      price.parentNode.insertBefore(box, price.nextSibling);
    } else if (last && last.parentNode) {
      last.parentNode.insertBefore(box, last.nextSibling);
    } else if (btns && btns.parentNode) {
      btns.parentNode.insertBefore(box, btns);
    } else {
      form.insertBefore(box, form.firstChild);
    }

    sync();
    return true;
  }

  /* ------------------------------------------------------------------ boot */

  function boot() {
    cfg = readConfig();
    if (!cfg) return;

    WANTS   = parseWants(cfg.wants);
    FONTS   = parseFonts(cfg.fonts);
    COLOURS = parseColours(cfg.colours);

    if (build()) return;

    /* the variant picker re-renders the product form after load */
    var tries = 0;
    var iv = setInterval(function () {
      if (build() || ++tries > 40) clearInterval(iv);
    }, 150);

    var host = document.querySelector('product-info, .product__info-container');
    if (host) {
      var pending = false;
      new MutationObserver(function () {
        if (pending) return;
        pending = true;
        setTimeout(function () {
          pending = false;
          if (!document.querySelector('.pi-block')) { built = false; build(); }
        }, 120);
      }).observe(host, { childList: true, subtree: true });
    }
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
})();